<div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="row">{{ "system-param.title" | translate }}</h2>
    <div *ngIf="topMenuIcons.length > 0">
      <button
          mat-raised-button
          [disabled]="
          !this.detailForm.valid"
          (click)="save()"
        >
        <mat-icon [title]="this.saveIconTitle"> save </mat-icon>
        </button>
        <button
          mat-raised-button
          *ngIf="this.id !== 'new'"
          (click)="deleteConfirm()"
        >
        <mat-icon [title]="this.deleteIconTitle"> delete </mat-icon>
        </button>
        <ng-container *ngFor="let action of topMenuIcons">
          <button
            mat-raised-button
            *ngIf="!action.hide"
            [routerLink]="action.routerLink"
            (click)="this[action.clickMethod]()"
          >
            <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
          </button>
        </ng-container>
    </div>
  </div>
  <form [formGroup]="detailForm">
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="40px">
        <mat-form-field
          *ngIf="columnsVisible.get('id')"
          [ngStyle]="{
            'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
            'min-width.px': 300
          }"
        >
          <mat-label> {{ "system-param.id" | translate }} </mat-label>
          <input
            matInput
            [ngStyle]="{
              'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
              'min-width.px': 300
            }"
            formControlName="id"
          />
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('key')"
          [ngStyle]="{
            'width.ch': detailForm.controls['key'].value ? detailForm.controls['key'].value.length : 10,
            'min-width.px': 300
          }"
        >
          <mat-label>{{ "system-param.key" | translate }}</mat-label>
          <input
            matInput
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['key'].value ? detailForm.controls['key'].value.length : 10,
              'min-width.px': 300
            }"
            formControlName="key"
          />
          <mat-error *ngIf="detailForm.controls['key'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('value')"
          [ngStyle]="{
            'width.ch': 10,
            'min-width.px': 600
          }"
        >
          <mat-label>{{ "system-param.value" | translate }}</mat-label>
          <textarea
            matInput
            class="form-control"
            [ngStyle]="{
              'width.ch': 10,
              'min-width.px': 580
            }"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10"

            formControlName="value"
          ></textarea>
          <mat-error *ngIf="detailForm.controls['value'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
        </mat-form-field>
       </div>

    </div>

    <mat-accordion multi>
      <mat-expansion-panel [expanded]="true"  *ngIf="this.id !== 'new'">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'log-messages.title' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
          <mat-panel-description>
        <app-log-messages-list [ngStyle]="{
          'width.pc': 100
        }" [modelId]="this.id"></app-log-messages-list>
        </mat-panel-description>
      </mat-expansion-panel>
    </mat-accordion>
  </form>


